<template>
  <div>
    <v-dialog
      :value="showDialog"
      width="400"
      @click:outside="close('overlay')"
      :persistent="!closeOnOverlayClick"
      :hide-overlay="hideOverlay"
    >
      <v-card>
        <v-card-title>
          <img class="bankId-icon" src="@/assets/icon_32x32@2x.png" />
          {{ headline }}
        </v-card-title>
        <v-card-text>
          <v-form ref="formBankId">
            <v-expansion-panels
              :accordion="true"
              :hover="true"
              v-model="bankIdOptionIndex"
            >
              <v-expansion-panel
                v-for="(bankIdOption, index) in bankIdOptions"
                :key="index"
                v-show="bankIdOptionIndex === index || bankIdOptionIndex === undefined"
              >
                <v-expansion-panel-header
                  @click="onBankIdOptionClick()"
                >
                  <div class="_expansion-panel-headline">
                    <span>{{ bankIdOption.name }}</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="text-center pa-10" v-if="showGetAutoStartTokenLoader">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                  <div v-if="qrCodeIsLoaded">
                    <ol>
                      <li>Öppna BankID-appen i mobilen.</li>
                      <li>Tryck på QR-symbolen i BankID-appen.</li>
                      <li>Rikta kameran mot QR-koden i denna ruta.</li>
                      <li>Legitimera dig själv i BankID-appen.</li>
                    </ol>
                    <div class="d-flex justify-center py-4">
                      <v-img :src="qrCodeSrc" max-height="150" max-width="150">
                      </v-img>
                    </div>
                  </div>
                  <template
                    v-if="autoStartTokenIsLoaded"
                  >
                    <!--apiMessage-->
                    <p class="subtitle-2">Status</p>
                    <p class="" v-html="apiMessage"></p>
                    <v-card-actions class="px-0">
                      <v-btn
                        outlined
                        @click="bankIdOptionIndex = undefined"
                        small
                      >Byt</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="bankIdOption.thisDevice"
                        color="accent"
                        :href="bankIdUrl"
                        small
                      >Öppna BankID</v-btn>
                    </v-card-actions>
                  </template>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-form>
        </v-card-text>
        <v-card-actions v-if="showCloseButton">
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="close('button')"
          >
            Avbryt
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import { snackBarBus } from '../main'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { mapGetters } from 'vuex'

export default {
  mixins: [generalMixin, urlMixin],
  props: {
    headline: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: false
    },
    dialog: {
      type: Boolean,
      default: false
    },
    hideOverlay: {
      type: Boolean,
      default: false
    },
    closeOnOverlayClick: {
      type: Boolean,
      default: true
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    returnUrl: {
      type: String,
      required: true
    },
    bankIdData: {
      type: Object,
      required: false
    }
  }, 
  data() {
    return {
      collectCallTimeout: null,
      bankIdUrl: '',
      bankIdOptions: [],
      bankIdOptionIndex: undefined,
      postData_collect: null,
      autoStartTokenCallSerieId_counter: -1,
      collectCallSerieId_counter: -1,
      bankIdWindow: null,
      changeQrCodeInterval: null,
      stateDefault: {
        autoStartTokenCallSerieId_active: null,
        collectCallSerieId_active: null,
        apiMessage: '',
        qrCodeSrc: '',
        secondCounter: 0,
        qrCodeSrcs: [],
        qrCodeIsLoaded: false,
        autoStartTokenIsLoaded: false,
        showGetAutoStartTokenLoader: false,
        showPersonNo: false,
        autoStartToken: '',
        personNo: ''
      },
      state: {}
    }
  },
  computed: {
    ...mapGetters(['isStandalone']),
    showDialog() {
      return this.dialog;
    },
    bankIdOption() {
      if (this.bankIdOptionIndex === undefined) {
        return null
      }
      return this.bankIdOptions[this.bankIdOptionIndex]
    },
    apiMessage() {
      return (this.state.apiMessage) ? this.state.apiMessage : ''
    },
    showGetAutoStartTokenLoader() {
      return (this.state.showGetAutoStartTokenLoader)
    },
    qrCodeIsLoaded() {
      return (this.state.qrCodeIsLoaded)
    },
    autoStartTokenIsLoaded() {
      return (this.state.autoStartTokenIsLoaded)
    },
    qrCodeSrc() {
      return (this.state.qrCodeSrc) ? this.state.qrCodeSrc : ''
    },
    autoStartToken() {
      return (this.state.autoStartToken) ? this.state.autoStartToken : ''
    },
    getBankIdUrl() {
      return this.bankIdUrl
    }
  },
  watch: {
    bankIdOptionIndex() {
      this.trace('bankIdOptionIndex', this.bankIdOptionIndex)
      //reset state
      this.resetState();
      if (this.bankIdOptionIndex === undefined) {
        return;
      }
      //set an unique id for this call in order to know if we (still) should treat its response
      this.state.autoStartTokenCallSerieId_active = this.getNextAutoStartTokenCallSerieId()
      this.getAutoStartToken(this.state.autoStartTokenCallSerieId_active)
    },
    autoStartToken() {
      //whenever autoStartToken changes, recompose the bankIdUrl
      this.bankIdUrl = this.composeBankIdUrl()
    }
  },
  methods: {
    close(referer) {
      switch (referer) {
        case 'overlay':
          if (!this.closeOnOverlayClick) {
            return;
          }
        break;
      }
      this.bankIdOptionIndex = undefined
      this.$emit('close')
    },
    onBankIdOptionClick() {
//      setTimeout(this.launchBankIdApp, 2000)
    },
    launchBankIdApp() {
//      this.bankIdWindow.location.href = this.composeBankIdUrl()
      /*
      const btn = this.$refs.btnOpenBankIDByScript
      console.log('btn', btn)
      btn.click()
      */
      const url = this.composeBankIdUrl()
      if (url.length) {
        let bankIdWindow = window.open(url)
        console.log('bankIdWindow', bankIdWindow)
      } else {
        console.log('bankIdUrl not set yet')
      }
    },
    composeBankIdUrl() {
      /* from the docs:
      3.1 Launching the BankID App From a Browser
      The URL syntax is:
      bankid:///?autostarttoken=[TOKEN]&redirect=[RETURNURL]
      The URL works on Android and iOS when the built-in web browser is used. The URL works on PCs with all commonly used browsers. Some differences exist on different platforms.
      On Android 6 and later and on iOS the preferred URL syntax is:
      https://app.bankid.com/?autostarttoken=[TOKEN]&redirect=[RETURNURL]
      Note that on Android the app.bankid.com link works when using the Chrome browser.
      Note that the redirect parameter must be last in the parameter list. The autostarttoken and rpref parameters are optional.
      Note that the parameter names must be lower case.
      Note that if the BankID app is started but no matching web service call to auth or sign has been done, an error message will be displayed in the app.
      3.1.1 Behaviour in Different Browsers
      3.1.1.1 Internet Explorer
      Internet Explorer manipulates the URL in the redirect parameter. In this specification, we state that the RETURNURL must be URL encoded. However, Internet Explorer decodes the content prior passing it to the BankID app. This is why it must be last in the list of parameters. In the same way, Internet Explorer may decode the content of the RETURNURL when the BankID app passes the return URL back to the browser. If the RP includes session information that is affected by URL encoders/decoders, problems may occur. It is recommended to use only URL encoding safe characters in the parameters.
      3.1.2 Parameters in the Start URL
      Redirect
      The BankID app uses the parameter redirect to launch the RP web app after completed (including cancelled) auth or sign. The redirect URL must be UTF-8 and URL encoded and should match the web address the user is visiting when RP web app launches the BankID app. It may include parameters to be passed to the browser. For iOS the redirect must have a value. For all other platforms it may be empty (“redirect=”), or set to “null” (“redirect=null”). If it is empty or null the BankID app will terminate without launching any URL and the calling application will be in focus. The general recommendation is to use redirect=null when it is possible.
      Note for Windows and macOS
      If redirect has a value the redirect parameter must be used together with autostarttoken. If autostarttoken is excluded, the content of redirect will be ignored and the behavior will be as if redirect=null.
      Note for Android
      If the user has several browsers installed on an Android device the user is sometimes presented with a question asking what browser to use. BankID recommends that redirect=null is used on Android. This ensures the user will return to the browser previously used.
      Note for iOS
      Redirect=null on iOS results in the RP web or app not being launched after completed auth or sign.
      */
//      let host = this.isMobile ? 'https://app.bankid.com/' : 'bankid:///'
      let host = 'bankid:///'
      //when redirect='null', bankID will return without refreshing the url, but when we set it to an url (which we must on iOS),  the browser (safari at least) will refresh the url, resulting in our collect polling being broken. BUT, if we include a '#writeanythingyoulikehere' in our return url, it won't :D
      let redirect = 'null'
      if (!this.isStandalone) {
        //if not standalone (not launched as PWA) we can encourage BankID to redirect to the browser on complete
        redirect = this.isIOS && this.isSystemBrowser ? encodeURI(window.location.href + '#norefresh') : 'null'
      }
      /*
      if (this.isIOS && !window.navigator.standalone && this.isSystemBrowser) {
        //if iOS AND not in PWA AND system browser, redirect back via url
        redirect = encodeURI(window.location.href + '#norefresh')
      }
      */
      let url = host + '?autostarttoken=' + this.autoStartToken + '&redirect=' + redirect
//      alert('bankIdUrl: ' + url)
      return url
    },
    getAutoStartToken(autoStartTokenCallSerieId)  {
      this.state.showGetAutoStartTokenLoader = true
      let postData = {
        mode: this.mode,
        useQrCode: this.bankIdOption.useQrCode
      }
      switch (this.mode) {
        case 'sign':
          postData.message = this.message
          postData.hiddenData = this.bankIdData.hiddenData
          break
      }
      let url = this.url_composeApiUrl('/bankid/getAutoStartToken')
      this.trace(url + ' post', postData)
      axios.post(url, postData)
        .then(response => {
          this.trace('post response', response)
          if (autoStartTokenCallSerieId !== this.state.autoStartTokenCallSerieId_active) {
            //this autoStartTokenCallSerieId is not longer active - abort it
            this.trace('autoStartTokenCallSerieId not active any longer')
            return
          }
          this.state.showGetAutoStartTokenLoader = false
          if (response.data.success) {
            //success
            this.state.autoStartToken = response.data.returnData.autoStartToken
            this.state.autoStartTokenIsLoaded = true
            if (this.bankIdOption.useQrCode) {
              //display qr code
              this.state.qrCodeSrcs = response.data.returnData.qrCodeSrcs;
              this.state.qrCodeSrc = this.state.qrCodeSrcs[0];
              this.state.qrCodeIsLoaded = true;
              // keep changing the qr code every second as long as we have "new" qrCodes in the return data form api
              this.changeQrCodeInterval = setInterval(function() {
                this.state.secondCounter++;
                if (this.state.secondCounter < this.state.qrCodeSrcs.length) {
                  this.state.qrCodeSrc = this.state.qrCodeSrcs[this.state.secondCounter];
                  console.log("qrCodeSrc", this.state.secondCounter, this.state.qrCodeSrc);
                } else {
                  clearInterval(this.changeQrCodeInterval);
                }
              }.bind(this), 1000);
            } else if (this.bankIdOption.autoStart) {
              //try to launch bankID app
              this.launchBankIdApp()
            }
            //init collect call
            this.initCollectCall(response.data.returnData.orderRef, this.bankIdOption.autoStart, this.bankIdOption.promptPersonalNumber)
          } else {
            //non success
            //display error
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          //disable loader
          this.state.showGetAutoStartTokenLoader = false
          //display error
          snackBarBus.$emit('message', error.toString())
        })
    },
    initCollectCall(orderRef, didAutoStart, didPromptPersonalNumber) {
      this.postData_collect={
        mode: this.mode,
        orderRef: orderRef,
        isMobile: this.isMobile,
        didAutoStart: didAutoStart,
        didPromptPersonalNumber: didPromptPersonalNumber
      }
      switch (this.mode) {
        case 'sign':
          this.postData_collect.bankIdData = this.bankIdData
          break
      }
      //set an unique id for this serie of collect calls in order to know if we (still) should treat its response
      this.state.collectCallSerieId_active = this.getNextCollectCallSerieId()
      this.doCollectCall(this.state.collectCallSerieId_active)
    },
    getNextAutoStartTokenCallSerieId() {
      this.autoStartTokenCallSerieId_counter++;
      return this.autoStartTokenCallSerieId_counter
    },
    getNextCollectCallSerieId() {
      this.collectCallSerieId_counter++;
      return this.collectCallSerieId_counter
    },
    doCollectCall(collectCallSerieId) {
//      this.trace('doCollectCall collectCallSerieId', collectCallSerieId)
      let url = this.url_composeApiUrl('/bankid/collect')
      axios.post(url, this.postData_collect)
        .then(response => {
//          this.trace('on doCollectCall collectCallSerieId', collectCallSerieId)
//          this.trace('collectCallSerieId_active', this.state.collectCallSerieId_active)
          if (collectCallSerieId !== this.state.collectCallSerieId_active) {
            //this collectCallSerieId is not longer active - abort it
//            this.trace('collectCallSerieId not active any longer')
            return
          }
//          this.trace('doCollectCall response', response)
          if (response.data.success) {
            //success
            switch (response.data.returnData.status) {
              case 'pending':
                //call again in 2 second
                this.state.apiMessage = response.data.returnData.message
                this.collectCallTimeout = setTimeout(() => {
                    this.doCollectCall(collectCallSerieId);
                  },
                  2000
                )
              break;
              case 'complete':
                this.state.apiMessage = '';
                this.onComplete(response.data.returnData);
              break;
              case 'failed':
                this.state.apiMessage = response.data.returnData.message;
                clearInterval(this.changeQrCodeInterval);
                this.state.qrCodeSrc = '';
              break;
            }
          } else {
            //non success
            //display error
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar));
          }
        })
        .catch(error => {
          //display error
          snackBarBus.$emit('message', error.toString());
        })
    },
    onComplete: function(returnData) {
      //close and 'return' token to parent
//      this.close();
      this.$emit('complete', returnData.token)
    },
    resetState() {
      //set state to a version of stateDefault without reference (so that this.stateDefault is not tampered when changing this.state)
      this.state = Object.assign({}, this.stateDefault);
    }
  },
  destroyed() {
    this.trace('BankID destroyed')
    if (this.collectCallTimeout) {
      clearTimeout(this.collectCallTimeout)
      this.trace('collectCallTimeout cleared')
    }
  },
  created() {
    //init state to default
    this.resetState();
    if (this.isMobile) {
      //mobile
      this.bankIdOptions.push({
        name: 'Mobilt BankID på denna enhet',
        label: 'mobileThis',
        autoStart: this.isSystemBrowser,
        thisDevice: true,
        promptPersonalNumber: false,
        useQrCode: false
      })
      this.bankIdOptions.push({
        name: 'Mobilt BankID på annan enhet',
        label: 'mobileOther',
        autoStart: false,
        thisDevice: false,
        promptPersonalNumber: false,
        useQrCode: true
      })
    } else {
      //desktop
      this.bankIdOptions.push({
        name: 'Mobilt BankID',
        label: 'mobileOther',
        autoStart: false,
        thisDevice: false,
        promptPersonalNumber: false,
        useQrCode: true
      })
      this.bankIdOptions.push({
        name: 'BankID på denna dator',
        label: 'thisComputer',
        autoStart: true,
        thisDevice: true,
        promptPersonalNumber: false,
        useQrCode: false
      })
    }
  }
}
</script>